<form [formGroup]="specHeffingskortingenFormGroup">
    <ng-container formGroupName="specificatieHeffingskortingen">
        <ng-container formGroupName="opbouw">
            <ng-container *ngFor="let propertyName of propertyNamesToCheck; let i = index">
                <ng-container *ngIf="i === 0 || i === 1">
                    <div class="flex-container-dialog">
                        <div class="flex-item-tekst-dialog">
                            <p>{{ propertyTextMap[propertyName] }}</p>
                        </div>
                        <div>
                            <snelstart-ui-number-form-control
                                    [formControlName]="propertyName"
                                    [id]="propertyName"
                                    class="custom-input-150"
                                    [decimals]="0"
                                    prefix="€"
                                    align="right"
                                    placeholder="0"
                                    [disabledControl]=true
                            >
                            </snelstart-ui-number-form-control>
                        </div>

                    </div>
                </ng-container>
                <ng-container *ngIf="i !== 0 && i !== 1">
                    <div *ngIf="getPropertyValue(propertyName)!== 0 && getPropertyValue(propertyName) !== null">
                        <div class="flex-container-dialog">
                            <div class="flex-item-tekst-dialog">
                                <p>{{ propertyTextMap[propertyName] }}</p>
                            </div>
                            <div>
                                <snelstart-ui-number-form-control
                                        [formControlName]="propertyName"
                                        [id]="propertyName"
                                        class="custom-input-150"
                                        [decimals]="0"
                                        prefix="€"
                                        align="right"
                                        [disabledControl]=true
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</form>

